import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper"
import AuthService from "../../../services/authService"

const fireBaseBackend = getFirebaseBackend()

// **AsyncThunk pour l'enregistrement d'un club**
export const registerClub = createAsyncThunk(
  "auth/register/club",
  async ({ club, history }, { rejectWithValue }) => {
    try {
      const response = await AuthService.register(club)
      const token = response.data.token
      localStorage.setItem("authUser", token)
      history("/login")

      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || "Error")
    }
  }
)

export const registerAgent = createAsyncThunk(
  "auth/register/Agent",
  async ({ agent, history }, { rejectWithValue }) => {
    try {
      const response = await AuthService.registerAgent(agent)
      const token = response.data.token
      localStorage.setItem("authUser", token)
      // history("/login")
      setTimeout(() => {
        history("/login?role=agent", {
          state: {
            message: "Inscription réussie ! Votre compte est en attente de validation par un administrateur.",
            type: "success",
            email: response?.data?.agent?.email,
          }
        });
      }, 1500);
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || "Error")
    }
  }
)

// **Création du Slice**
const registerSlice = createSlice({
  name: "register",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetRegistrationError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerClub.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(registerClub.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
      })
      .addCase(registerClub.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(registerAgent.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(registerAgent.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
      })
      .addCase(registerAgent.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetRegistrationError } = registerSlice.actions

export default registerSlice.reducer
